// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"performLookup_footerContainer__1j7Y2","container":"performLookup_container__2rpQ1","lookupContainer":"performLookup_lookupContainer__29sRl"};